"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageVideoType = exports.VideoDataVidyardFields = exports.VideoDataEmbedFields = exports.VideoDataFields = exports.MessagingDataFields = exports.MeetingHostsFields = exports.MessageFields = exports.RecipientActionsFields = void 0;
var RecipientActionsFields;
exports.RecipientActionsFields = RecipientActionsFields;

(function (RecipientActionsFields) {
  RecipientActionsFields["CapturePhone"] = "capturePhone";
  RecipientActionsFields["CaptureEmail"] = "captureEmail";
  RecipientActionsFields["CaptureDate"] = "captureDate";
  RecipientActionsFields["CaptureAffidavit"] = "captureAffidavit";
  RecipientActionsFields["CaptureQuestion"] = "captureQuestion";
  RecipientActionsFields["GifterQuestion"] = "gifterQuestion";
  RecipientActionsFields["GifterAffidavit"] = "gifterAffidavit";
})(RecipientActionsFields || (exports.RecipientActionsFields = RecipientActionsFields = {}));

var MessageFields;
exports.MessageFields = MessageFields;

(function (MessageFields) {
  MessageFields["MessageSubject"] = "messageSubject";
  MessageFields["MessageBody"] = "messageBody";
  MessageFields["SendAsPersons"] = "sendAsPersons";
  MessageFields["TemplateId"] = "templateId";
})(MessageFields || (exports.MessageFields = MessageFields = {}));

var MeetingHostsFields;
exports.MeetingHostsFields = MeetingHostsFields;

(function (MeetingHostsFields) {
  MeetingHostsFields["OwnerId"] = "ownerId";
  MeetingHostsFields["AttendeeIds"] = "attendeeIds";
  MeetingHostsFields["IsAttendeeEnabled"] = "__isAttendeeEnabled";
})(MeetingHostsFields || (exports.MeetingHostsFields = MeetingHostsFields = {}));

var MessagingDataFields;
exports.MessagingDataFields = MessagingDataFields;

(function (MessagingDataFields) {
  MessagingDataFields["Message"] = "message";
  MessagingDataFields["RecipientActions"] = "recipientActions";
  MessagingDataFields["MeetingHosts"] = "meetingHosts";
  MessagingDataFields["VideoData"] = "video";
})(MessagingDataFields || (exports.MessagingDataFields = MessagingDataFields = {}));

var VideoDataFields;
exports.VideoDataFields = VideoDataFields;

(function (VideoDataFields) {
  VideoDataFields["Type"] = "type";
  VideoDataFields["Embed"] = "embed";
  VideoDataFields["Vidyard"] = "vidyard";
})(VideoDataFields || (exports.VideoDataFields = VideoDataFields = {}));

var VideoDataEmbedFields;
exports.VideoDataEmbedFields = VideoDataEmbedFields;

(function (VideoDataEmbedFields) {
  VideoDataEmbedFields["VideoUrl"] = "videoUrl";
})(VideoDataEmbedFields || (exports.VideoDataEmbedFields = VideoDataEmbedFields = {}));

var VideoDataVidyardFields;
exports.VideoDataVidyardFields = VideoDataVidyardFields;

(function (VideoDataVidyardFields) {
  VideoDataVidyardFields["ImageUrl"] = "imageUrl";
  VideoDataVidyardFields["VideoUrl"] = "videoUrl";
})(VideoDataVidyardFields || (exports.VideoDataVidyardFields = VideoDataVidyardFields = {}));

var MessageVideoType;
exports.MessageVideoType = MessageVideoType;

(function (MessageVideoType) {
  MessageVideoType["Embed"] = "embed";
  MessageVideoType["Vidyard"] = "vidyard";
})(MessageVideoType || (exports.MessageVideoType = MessageVideoType = {}));